$(document).ready(function() {
  $('body').on("click",".blog_natg_button",function(e){
    e.preventDefault();
    var _this = $(this);
    $('.blog_natg_button').addClass("button--secondary");
    $('.pagination_blog').show(); 
    $('.blog_title_changed').html(_this.html());
    _this.removeClass("button--secondary");
    $.get(_this.attr("href"),function (data) {
      $('.blog-articles').html($(data).find('.blog-articles').html());
      $('.blog_title_changed').html($(data).find('.blog_title_changed').html());
      $('.pagination_blog').html($(data).find('.pagination_blog').html());
      history.pushState("","",_this.attr("href"));
    });
  });

  $('body').on("submit",".search_blog",function(event){
    event.preventDefault();
    event.stopPropagation();

    if($(this).find('input').val() != '') {
       $.ajax({
      type: 'GET',
      url: "/search?view=blog_search&type=articles&q="+$(this).find('input').val(),
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        $(this).append('<p class="product_error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
      }
    }).done(function( data ) {
      $('.blog-articles').html(data);
       $('.pagination_blog').hide();
    });
    } else {
      $.get(window.location.href,function (data) {
        $('.blog-articles').html($(data).find('.blog-articles').html());
        $('.pagination_blog').show();
        history.pushState("","",_this.attr("href"));
      });
    }
    
    
  });
 
  $(".blog_title_changed").click(function () {
        $(".all_blogs_list").slideToggle(200);
        $(".chevron").toggleClass("rotate");
    });

    $(".blog_list--item").click(function () {
        window.location.href = $(this).data("href");
    });

    $(document).click(function (e) {
        if (!$(e.target).closest(".blog_title_list_wrp").length) {
            $(".all_blogs_list").slideUp(200);
            $(".chevron").removeClass("rotate");
        }
    });

  
});